import { render, staticRenderFns } from "./BuildFilterButtonComp.vue?vue&type=template&id=fb47f980&scoped=true&"
import script from "./BuildFilterButtonComp.vue?vue&type=script&lang=ts&"
export * from "./BuildFilterButtonComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb47f980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
